// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import FilmDetail from '../views/FilmDetail.vue';
import ContactView from '../views/ContactView.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
  },
  {
    path: '/film/:id',
    name: 'FilmDetail',
    component: FilmDetail,
    props: true, // Permet de passer l'id en tant que prop au composant
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // Attendre que le DOM soit mis à jour avant de réinitialiser le scroll
    return new Promise((resolve) => {
      // Utilisez Vue.nextTick() pour attendre la fin du rendu
      setTimeout(() => {
        resolve({ top: 0 });
      }, 0);
    });
  }
});




export default router;
